import { ZendeskGlobalMethod } from '../zendesk.t';
import { IConversationField } from "../Zendesk";

abstract class ZendeskWebWidget {
    protected type: string;

    zE(arg1: string, arg2: string, arg3?: any): ReturnType<ZendeskGlobalMethod> {
        if (window.zE) {
            window.zE(arg1, arg2, arg3);
        }
    }

    abstract hide(): void;

    abstract show(): void;

    abstract open(): void;

    abstract close(): void;

    abstract setLocale(locale: string): void;

    abstract onClose(callback: () => void): void;

    abstract login(params: { email: string, token: string, uid: number }): void;

    abstract logout(): void;

    abstract onUnreadMessages(callback: (count: number) => void): void;

    abstract init(closeCallback?: () => void): void;

    abstract setConversationTags(tags: string[]): void;

    abstract setConversationFields(conversationFields?: IConversationField[]): void;
}

export default ZendeskWebWidget;
